import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

import normalizeStronghold from '../schemas/stronghold'

export const STRONGHOLD_LOAD_REQUEST = 'stronghold/REQUEST'
export const STRONGHOLD_LOAD_SUCCESS = 'stronghold/SUCCESS'
export const STRONGHOLD_LOAD_ERROR = 'stronghold/ERROR'

export function requestSuccess(data) {
    const { id, level, arena, stats, clan, elo_leaderboards } = data
    const { slots, buildings } = normalizeStronghold(data)

    const payload = {
        id,
        level,
        slots,
        arena,
        buildings,
        stats,
        clan,
    }

    if (elo_leaderboards) {
        payload.elo_leaderboards = elo_leaderboards.sort((a, b) => b.vehicle_level - a.vehicle_level)
    }

    return {
        type: STRONGHOLD_LOAD_SUCCESS,
        payload,
    }
}

export function requestError(errorData) {
    sendErrorNotification(errorData)

    return {
        type: STRONGHOLD_LOAD_ERROR,
        payload: errorData,
    }
}

export function requestStronghold(clanId = null, language) {
    return async (dispatch, getState) => {
        const state = getState()
        if (state.stronghold.loading) {
            return
        }
        dispatch({ type: STRONGHOLD_LOAD_REQUEST })
        const isOwn = clanId === null
        const url = isOwn ?
            '/game_api/stronghold_info' :
            `/game_api/stronghold_info/clan/${clanId}`

        httpRequest(url, 'GET', {}, language)
            .then(
                resp => dispatch(requestSuccess(resp)),
                errorData => dispatch(requestError(errorData))
            )
    }
}



// WEBPACK FOOTER //
// ./state/actions/stronghold.js